import { render } from "./OrganizationChart.vue?vue&type=template&id=1d1b1d8e"
import script from "./OrganizationChart.vue?vue&type=script&lang=js"
export * from "./OrganizationChart.vue?vue&type=script&lang=js"

import "./OrganizationChart.vue?vue&type=style&index=0&id=1d1b1d8e&lang=css"
script.render = render

export default script